import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(() => ({
  drawerText: {
    flexGrow: 1,
    alignContent: "center",
  },
}));

interface ICookieConsentDrawerProps {
  isOpen: boolean;
  onAcceptAll: () => void;
  onRejectAll: () => void;
  onReadMore: () => void;
}

/**
 * This component is responsible for rendering a modal footer ('Drawer'),
 * which provides the user with a summary of how cookies and similar
 * technologies are used, prompting them to accept or reject
 * tracking cookies, or find out more (e.g. by opening a modal dialog).
 *
 * It does not directly interact with the storage of this choice, and simply
 * calls one of the following props when the buttons are clicked:
 *
 * - onAcceptAll
 * - onRejectAll
 * - onReadMore
 */
export const CookieConsentDrawer = (props: ICookieConsentDrawerProps) => {
  const { isOpen, onAcceptAll, onRejectAll, onReadMore } = props;
  const { t } = useTranslation();
  const { t: st } = useTranslation("snippets");
  const classes = useStyles();
  const CookiesSummarySnippet = st("CookiesSummary");

  return (
    <Drawer open={isOpen} anchor="bottom" variant="persistent">
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        flexWrap={{ xs: 'wrap', md: 'inherit' }}
      >
        <Box className={classes.drawerText} p={1}>
          <CookiesSummarySnippet />
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          flexWrap={{ xs: 'wrap', md: 'nowrap' }}
          p={1}
          gap={1}
        >
          {onReadMore && (
            <Button onClick={onReadMore} variant="text" sx={{ whiteSpace: "nowrap" }}>
              {t("Read More")}
            </Button>
          )}
          <Button onClick={onRejectAll} variant="outlined">
            {t("Reject")}
          </Button>
          <Button onClick={onAcceptAll} variant="contained" autoFocus={true}>
            {t("Accept")}
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};
